const storeState = {
  catalog: null,
  itemsList: [],
  categories: [],
};

const findCheapest = (list) => {
  if (!list || list.length === 0) {
    return 0;
  }
  let base = 0;
  if (Array.isArray(list) && list.length > 0) {
    base = list[0].price;
    list.forEach((item) => {
      if (item.price < base) {
        base = item.price;
      }
    });
  } else {
    base = list.price;
  }
  return parseFloat(base);
};

const mergeTwo = (child, parent) => {
  const parentArray = JSON.parse(JSON.stringify(parent));
  const merged = child.map((item) => {
    let found = null;
    parentArray.forEach((item2, index) => {
      if (item.name.en === item2.name.en) {
        found = index;
      }
    });
    if (found !== null) {
      parentArray.splice(found, 1);
    }
    return item;
  });
  return merged.concat(parentArray);
};
const shouldOpenModal = (item) => {
  if ((item.settings && !item.settings.askDetails) &&
    item.sizes && item.sizes.length === 1 &&
    item.styles && item.styles.length === 1 &&
    (!item.options || item.options.length === 0) &&
    item.variants && item.variants.length && item.variants.length === 1) {
    let defaultStyle;
    let defaultSize;
    let defaultVariant;
    if (item.styles.length > 1) {
      item.styles.forEach((style, index) => {
        if (style.isDefault) defaultStyle = index;
      });
    }
    if (item.sizes.length > 1) {
      item.sizes.forEach((size, index) => {
        if (size.isDefault) defaultSize = index;
      });
    }
    if (item.variants.length > 1) {
      item.variants.forEach((variant, index) => {
        if (variant.isDefault) defaultVariant = index;
      });
    }
    if (
      (!defaultStyle && item.styles.length !== 1) ||
      (!defaultSize && item.sizes.length !== 1) ||
      (!defaultVariant && item.variants.length !== 1)
    ) {
      return true;
    }
    return false;
  }
  return true;
};

const populateRequiredFields =
  (original, baseSizes, baseVariants, baseOptions, baseStyles) => {
    const sizes = baseSizes || [];
    const variants = baseVariants || [];
    const options = baseOptions || [];
    const styles = baseStyles || [];
    const item = original;
    if (!item.items || (item.items && item.items.length === 0)) {
      item.price = findCheapest(item.sizes) + findCheapest(item.variants);
      if (isNaN(item.price)) {
        item.price = '';
        item.disabled = true;
        item.warning = 'Sizes or Variants are not set for this item!';
      }
      if (!item.settings) {
        item.settings = {};
        item.settings.askDetails = false;
      }
      item.shouldOpenModal = shouldOpenModal(item);
    } else if (item.items && item.items.length) {
      item.items = item.items.map((current) => {
        const currentItem = current;
        currentItem.sizes = currentItem.sizes && currentItem.sizes.length ?
          mergeTwo(currentItem.sizes, sizes) : sizes;
        currentItem.variants = currentItem.variants && currentItem.variants.length ?
          mergeTwo(currentItem.variants, variants) : variants;
        currentItem.options = currentItem.options && currentItem.options.length ?
          mergeTwo(currentItem.options, options) : options;
        currentItem.styles = currentItem.styles && currentItem.styles.length ?
          mergeTwo(currentItem.styles, styles) : styles;
        currentItem.options = currentItem.options.map((currentOption) => {
          const option = currentOption;
          option.checked = false;
          return option;
        });
        if (currentItem.items && currentItem.items.length > 0) {
          currentItem.items = currentItem.items.map(childItem =>
            populateRequiredFields(
              childItem,
              childItem.sizes,
              childItem.variants,
              childItem.options,
              childItem.styles,
            ));
        } else {
          currentItem.price = findCheapest(currentItem.sizes) + findCheapest(currentItem.variants);
          if (isNaN(currentItem.price)) {
            currentItem.price = '';
            currentItem.disabled = true;
            currentItem.warning = 'Sizes or Variants are not set for this item!';
          }
          if (!currentItem.settings) {
            currentItem.settings = {};
            currentItem.settings.askDetails = false;
          }
          currentItem.shouldOpenModal = shouldOpenModal(currentItem);
        }
        return currentItem;
      });
    }
    return item;
  };

const mutations = {
  setCatalog(state, data) {
    if (!data) return;
    const catalog = JSON.parse(JSON.stringify(data));
    const view = catalog.views.find(current => current.name.en === 'Webshop');
    if (!view) return;
    // eslint-disable-next-line
    state.itemsList = [];
    // eslint-disable-next-line
    state.categories = [];
    const { viewId } = view;
    if (catalog.itemsList) {
      catalog.itemsList = catalog.itemsList.filter(current =>
        current.views.includes(viewId) && current.items && current.items.length > 0);
      catalog.itemsList.forEach((current) => {
        state.categories.push(current.name.en);
      });
      catalog.itemsList = catalog.itemsList.map(item =>
        populateRequiredFields(
          item,
          item.sizes,
          item.variants,
          item.options,
          item.styles,
        ));
    }
    // eslint-disable-next-line
    state.catalog = catalog;
    state.catalog.itemsList.forEach((category) => {
      category.items.forEach(item => state.itemsList.push(item));
    });
  },
  editCatalog(state, data) {
    // eslint-disable-next-line
    state.catalog[data.index] = data.catalog;
  },
};

const getters = {
  catalog() {
    return storeState.catalog;
  },
  categories() {
    return storeState.categories;
  },
  items() {
    return storeState.catalog.itemsList;
  },
  itemsList() {
    return storeState.itemsList;
  },
};

const actions = {
  setCatalog({ commit }, catalog) {
    commit('setCatalog', catalog);
  },
  editCatalog({ commit }, data) {
    commit('editCatalog', data);
  },
};

export default {
  state: storeState,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/catalog.js